<script>
import BreadcrumbNav from "@/components/BreadcrumbNav";
import TypeForm from "@/components/forms/TypeForm";

export default {
    components: {
        BreadcrumbNav,
        TypeForm
    },
    created() {
        const workspaceId = this.$route.params.workspaceId;
        this.workspace = this.$store.getters["workspaces/getWorkspace"](workspaceId);

        this.breadcrumbItems = [
            {
                name: this.Utils.capitalize(this.$t("main.types")),
                route: {
                    name: "types.index",
                    params: {
                        workspaceId: this.workspace.id
                    }
                }
            },
            {
                active: true,
                name: this.Utils.capitalize(this.$t("main.create"))
            }
        ];
    }
};
</script>

<template>
    <div class="container container-small my-5">
        <BreadcrumbNav :items="breadcrumbItems" />
        <div class="card">
            <div class="card-header">{{ Utils.capitalize($t("main.create_a_type")) }}</div>
            <div class="card-body">
                <TypeForm />
            </div>
        </div>
    </div>
</template>
